import React, { useState } from 'react';
import {
  Overlay,
  ModalContainer,
  Title,
  Subtitle,
  ItemRow,
  ItemLabel,
  ItemValue,
  QtdWrapper,
  QtdLabel,
  QtdInput,
  ActionsContainer,
  CancelButton,
  ConfirmButton,
} from './style';

interface Props {
  item: { id: number; descricao: string; quantidade: number };
  onConfirm: (quantidade: number) => Promise<void>;
  onCancel: () => void;
}

const RemoveInvoiceItemModal: React.FC<Props> = ({ item, onConfirm, onCancel }) => {
  const [qtd, setQtd] = useState<string>(String(item.quantidade));
  const [loading, setLoading] = useState(false);

  const qtdNum = Number(qtd);
  const isValid = qtdNum > 0 && qtdNum <= item.quantidade;

  const handleConfirm = async () => {
    if (!isValid) return;
    setLoading(true);
    try {
      await onConfirm(qtdNum);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay onClick={onCancel}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Title>Remover item da nota</Title>
        <Subtitle>Informe quantas unidades deseja remover. O restante voltará a ficar disponível para faturamento pelo pedido.</Subtitle>

        <ItemRow>
          <ItemLabel>Item</ItemLabel>
          <ItemValue>{item.descricao}</ItemValue>
        </ItemRow>
        <ItemRow>
          <ItemLabel>Quantidade na nota</ItemLabel>
          <ItemValue>{item.quantidade}</ItemValue>
        </ItemRow>

        <QtdWrapper>
          <QtdLabel>Qtd a remover</QtdLabel>
          <QtdInput
            type="number"
            min={1}
            max={item.quantidade}
            value={qtd}
            onChange={(e) => setQtd(e.target.value)}
          />
        </QtdWrapper>

        <ActionsContainer>
          <CancelButton onClick={onCancel} disabled={loading}>Cancelar</CancelButton>
          <ConfirmButton onClick={handleConfirm} disabled={!isValid || loading}>
            {loading ? 'Removendo…' : 'Remover'}
          </ConfirmButton>
        </ActionsContainer>
      </ModalContainer>
    </Overlay>
  );
};

export default RemoveInvoiceItemModal;
